import React, { memo, useEffect, useState } from "react";
import FooterSection from "../Components/FooterSection";
import Header from '../Components/Header';
import PageTitleSection from "../Components/PageTitleSection";
import ServicesAboutThreeColSection from "../Components/ServicesAboutThreeColSection";
import ContentLeftVideoRight from "../Components/ContentLeftVideoRight";
import PlainContent from "../Components/PlainContent";
import HttpHelper from '../service/httpService'
import Spacer from "../Components/Spacer";
import BrandLogoSliderSection from "../Components/BrandLogoSliderSection";

const AboutUsPage = () => {
    const [pageContent, setPageContent] = useState();
    const getSettingData = async () => {
        await HttpHelper.get("Website/GetAboutUs").then((response) => {
            if (response.status == 200) {
                setPageContent(response.data);
            }
        })
    };

    useEffect(() => {
        getSettingData();
    }, []);

    return (
        <>
            <Header />
            <PageTitleSection
                title="About Us"
                pagetitle="About Us"
                subtitle="No Deficiencies. No Exceptions. Our Standard, not our motto."
            />

            <ServicesAboutThreeColSection
                bgClass="blackBg"
                iconOne={pageContent && pageContent.length > 0 && pageContent[0].file ? pageContent[0].file.fileUrl : ''}
                titleOne={pageContent && pageContent.length > 0 && pageContent[0].heading}
                titleOneDesc={pageContent && pageContent.length > 0 && pageContent[0].content}
                urlOne=""

                iconTwo={pageContent && pageContent.length > 1 && pageContent[1].file ? pageContent[1].file.fileUrl : ''}
                titleTwo={pageContent && pageContent.length > 1 && pageContent[1].heading}
                titleTwoDesc={pageContent && pageContent.length > 1 && pageContent[1].content}
                urlTwo=""

                iconThree={pageContent && pageContent.length > 2 && pageContent[2].file ? pageContent[2].file.fileUrl : ''}
                titleThree={pageContent && pageContent.length > 2 && pageContent[2].heading}
                titleThreeDesc={pageContent && pageContent.length > 2 && pageContent[2].content}
                urlThree="" />
            <div style={{ width: '68%', margin: '0 auto' }} className="mb-xl-10">
                <h2 ><b>{pageContent && pageContent.length > 3 ? pageContent[3].heading : ''}</b></h2>
                <div className="bgnone" dangerouslySetInnerHTML={{ __html: pageContent && pageContent.length > 3 && pageContent[3] != null ? pageContent[3].content : '' }}></div>
            </div>

            <section className="section blackBg mb-10">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-xl-12 col-12">
                            <BrandLogoSliderSection removeExtra={false} />
                        </div>
                    </div>
                </div>
            </section>

            <FooterSection />
        </>
    )
}

export default memo(AboutUsPage);